import { AxonTrack } from '../types/Axon';
import { zendeskCancellationReason } from '../types/gql-op-types';
import { NorthbeamAnalytics } from '../types/NorthbeamAnalytics';

interface IGTagDataLayer {
  push(...args: any[]): void;
}

interface adaResetArgs {
  greeting: string;
  metaFields: { customername: string; email: string; 'SubCancel-Reason': zendeskCancellationReason };
}

export interface AnalyticsMessage {
  event: string;
  properties: Object;
  options?: SegmentAnalytics.SegmentOpts;
}

export interface FiAnalyticsJS extends SegmentAnalytics.AnalyticsJS {
  off?: (event: string, fn: Function) => void;
}

export interface IWindow extends Window {
  recurly: any;
  fbq?: any;
  /**
   * Agentio pixel for CTC attribution
   */
  initAgentioPixel?: (pixelId: string) => void;
  agentioConversionHandler?: (detail: { detail: { conversionType: string; value?: number } }) => void;
  /**
   * Northbeam marketing platform pixel
   */
  Northbeam?: NorthbeamAnalytics;

  analytics?: FiAnalyticsJS;

  axon?: AxonTrack;

  dataLayer?: IGTagDataLayer;

  letterpress?(...args: any[]): void;

  ApplePaySession?: typeof ApplePaySession;

  hj?: typeof HotJar.hj;

  // ada.cx is our CX chat provider, embedded via Google Tag Manager (https://tagmanager.google.com/#/container/accounts/4701326477/containers/11191378/workspaces/139/tags/32)
  adaEmbed?: {
    toggle(): void;
    reset(args: adaResetArgs): () => void;
  };

  // Decagon chat widget
  duet?: {
    setUserId: (id: string) => void;
    setUserIdAuth?: (signature: string, epoch: number) => void;
    setMetadata: (metadata: Record<string, any>) => void;
  };
}

export const typedWindow: IWindow = window;
